

(function errorsServiceDefinition() {

    'use strict';

    angular.module('Errors')
        .provider('errors', function errorsProvider() {

            this.$get = ['messages',
                function errorsFactory(messages) {

                    console.warn('El uso del servicio errors está deprecado, por favor utilice messages.');

                    return messages;
                }
            ];
        });
})();